import { service } from '../../../helpers/http'

//Retorna a lista com as categorias de grupos
export const ActionGetShifts = ({ dispatch }, payload) => {

    return service({
        module: 'domainShift',
        action: 'getShifts',
        payload: payload
    })
    
}

//Cadastra uma nova categoria de grupo
export const ActionPostShifts = ({ dispatch }, payload) => {

    return service({
        module: 'domainShift',
        action: 'postShifts',
        payload: payload
    })
    
}

//Atualiza uma categoria de grupo
export const ActionPutShifts = ({ dispatch }, payload) => {

    return service({
        module: 'domainShift',
        action: 'putShifts',
        payload: payload
    })
    
}

//Deleta uma categoria de grupo
export const ActionDeleteShifts = ({ dispatch }, payload) => {

    return service({
        module: 'domainShift',
        action: 'deleteShifts',
        payload: payload
    })
    
}